import { openOrCloseGlobalDialog } from '../../action/dialog/global-dialog';
import { createGenericDispatcher } from '../action-dispatcher-factory';

import * as Api from '../../api/api';
import { GLOBAL_DIALOGS } from '../../dialogs/global-dialogs-config';
import { addNotificationAction } from '../notifications/notifications';

export const updateOrg = (orgId: number, update: Partial<Org>) =>
  createGenericDispatcher({
    name: 'UPDATE_ORGANIZATION',
    loadFunction: () =>
      Api.post(`/org/${orgId}/`, {
        body: JSON.stringify({
          update,
        }),
      }),
    args: { orgId, update },
    onSuccess: (dispatch: Function, _getState: Function, data: any) => {
      if (data.errorMessage) {
        dispatch(openOrCloseGlobalDialog(GLOBAL_DIALOGS.GLOBAL_ERROR.key, true));
      } else if (
        update.forwardingPhoneNumber ||
        update.forwardingPhoneNumberForCalls ||
        update.jobForwardingPhoneNumber ||
        update.employeeForwardingPhoneNumber
      ) {
        dispatch(
          addNotificationAction({
            key: `update-org-phone-number-${orgId}`,
            message: 'Updated Company Defaults',
          }),
        );
      }
    },
  });
